import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { ClientsSection } from '../components/ClientsSection';
import { FAQSection } from '../components/FAQSection';
import { JobVacancies } from '../components/JobVacancies';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white" data-id="element-419">
      <Header data-id="element-420" />
      <main data-id="element-421">
        <HeroSection data-id="element-422" />
        <ServicesSection data-id="element-423" />
        <ClientsSection data-id="element-424" />
        <FAQSection data-id="element-425" />
        <JobVacancies data-id="element-426" />
        <ContactSection data-id="element-427" />
      </main>
      <Footer data-id="element-428" />
    </div>;
}